import { render, staticRenderFns } from "./PaymentRemittances.vue?vue&type=template&id=3f9f7fb3&scoped=true"
import script from "./PaymentRemittances.vue?vue&type=script&lang=ts"
export * from "./PaymentRemittances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f7fb3",
  null
  
)

export default component.exports